import {getPublicKey} from "@/api/auth";
import JSEncrypt from 'jsencrypt'
import {lsRemove, parseTime} from "@/utils/index";

const PemKey = 'pem'

/**
 * 移除公钥
 */
export function removePem() {
    return lsRemove(PemKey)
}

/**
 * 获取过期时间
 * 次日凌晨4点
 * @returns {number}
 */
function getExpirationTime() {
    const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    const tomorrow_date = parseTime(tomorrow, '{y}-{m}-{d}')
    return new Date(`${tomorrow_date} 04:00:00`).getTime()
}

/**
 * 公钥信息
 * @returns {Promise<*>}
 */
async function getPemPublicKey() {
    const pem_cache = localStorage.getItem(PemKey)
    const pem = JSON.parse(pem_cache)
    const currentTime = new Date().getTime()
    // 1. 缓存信息不存在
    // 2. 信息存在 但已过期
    // 3. 信息存在 过期时间不存在
    if ((pem && (pem.expiration_time < currentTime || !pem.expiration_time)) || !pem_cache) {
        const response = await getPublicKey();
        if (response.success) {
            const content = JSON.stringify({
                data: response.model,
                expiration_time: getExpirationTime()
            })
            localStorage.setItem(PemKey, content)
        }
        return response.model;
    } else {
        return pem.data;
    }
}

/**
 * 公钥加密数据
 * @param data
 * @returns {*}
 */
export async function getEncrypt(data) {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(await getPemPublicKey())
    return encrypt.encrypt(data)
}